import React from 'react';

// Liste yeniden sıralandığında elemanların yer değişimini FLIP tekniğiyle animasyonlar:
// eski konum ölçülür, eleman eski yerine transform'la geri atılır ve sıfıra doğru oynatılır.
//
// Konum offsetLeft/offsetTop ile ölçülür (getBoundingClientRect değil), çünkü bunlar
// transform'dan etkilenmez; dnd-kit'in sürükleme sırasında uyguladığı transform'lar ölçüme karışmaz.
//
// ÖNEMLİ (performans): ölçüm YALNIZCA orderKey değiştiğinde yapılır. dnd-kit sürükleme
// boyunca çok sık render eder; her render'da tüm çocukların layout'unu okumak "forced reflow"
// yaratıp mobilde sürüklemeyi tıkardı. Bu yüzden orderKey (seçim state'i) sürükleme sırasında
// sabit tutulur ve ölçüm sadece seçim değiştiğinde tetiklenir.
//
// containerRef: fotoğrafların doğrudan çocuğu olduğu element.
// orderKey: kimliği değiştiğinde animasyonun tetikleneceği değer (yeni referans üretmeli).
const useFlipOnReorder = (containerRef, orderKey) => {
    const oldPositions = React.useRef(new Map());
    const previousOrderKey = React.useRef(orderKey);

    // FIRST: orderKey'in değiştiği render sırasında, DOM henüz güncellenmeden eski konumları al.
    // Render sırasında containerRef.current bir önceki commit'in DOM'unu gösterir — FLIP "first" anı.
    // Sadece orderKey değiştiğinde okunur; sürükleme sırasında bu blok hiç çalışmaz.
    if(previousOrderKey.current !== orderKey && containerRef.current){
        const positions = new Map();

        // DOM düğümleri React tarafından taşındığı için eleman kimliği sabit kalır,
        // dolayısıyla Map'i doğrudan elemanla anahtarlayabiliyoruz.
        Array.from(containerRef.current.children).forEach( (child) => {
            positions.set(child, {x: child.offsetLeft, y: child.offsetTop});
        });

        oldPositions.current = positions;
    }

    // LAST + INVERT + PLAY: DOM güncellendikten sonra yeni konumları ölç ve farkı oynat.
    React.useLayoutEffect(() => {
        const container = containerRef.current;

        if(previousOrderKey.current === orderKey || !container){
            previousOrderKey.current = orderKey;
            return;
        }

        Array.from(container.children).forEach( (child) => {
            const previous = oldPositions.current.get(child);

            if(!previous || typeof child.animate !== 'function'){
                return;
            }

            const deltaX = previous.x - child.offsetLeft;
            const deltaY = previous.y - child.offsetTop;

            if(deltaX === 0 && deltaY === 0){
                return;
            }

            child.animate(
                [
                    {transform: `translate(${deltaX}px, ${deltaY}px)`},
                    {transform: 'translate(0px, 0px)'}
                ],
                {duration: 260, easing: 'cubic-bezier(0.2, 0, 0.2, 1)'}
            );
        });

        previousOrderKey.current = orderKey;
    });
};

export default useFlipOnReorder;
